import {useState, useEffect} from "react"

import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

import Resume from "../Resume/Resume";
import Projects from "../Projects/Projects";
import Mentorship from "../Mentorship/Mentorship";
import SocialMediaHero from "./SocialMediaHero";


const BottomHalf = () => {

    const [projectsRef, projectsInView] = useInView({
        triggerOnce: true,
        rootMargin: '-80px 0px',
    });

    const [mentorshipRef, mentorshipInView] = useInView({
        triggerOnce: true,
        rootMargin: '-80px 0px',
    });

    const [socialRef, socialInView] = useInView({
        triggerOnce: true,
        rootMargin: '-80px 0px',
    });

    const [experienceRef, experienceInView] = useInView({
        triggerOnce: true,
        rootMargin: '-80px 0px',
    });
    

    const [darkMode, setDarkMode] = useState(false)
    var darkModeStatus = false;

    if(typeof window !== 'undefined')
        darkModeStatus = JSON.parse(localStorage.getItem('connor-underwood-dark'))
    
    useEffect(() => {
        if(darkModeStatus) {
            setDarkMode(darkModeStatus)
        }
        console.log(darkModeStatus)
    }, [darkModeStatus])
    

    return (
        <div>
            
            {/*
            <div className='bg-white dark:bg-gray-800'>
                <Wave 
                    fill={"#1f2937"}
                    paused={false}
                    options={{
                        amplitude: 5,
                        speed: 0.25,
                        points: 3
                    }}
                    style={{height: "40px", marginBottom: "-20px"}}
                />
            </div>
            */}

            <div>
                
                <div className='max-w-7xl mx-auto p-4 sm:p-6'>
                    
                    <div
                        ref={mentorshipRef}
                        className='my-4'
                        id="mentorship"
                    >
                        {mentorshipInView ?
                            <>
                                <motion.div
                                    className='my-4 text-right flex justify-right items-center ml-auto w-fit gap-4'
                                    initial={{opacity: 0, x: 50}}
                                    animate={{opacity: 1, x: 0}}
                                    transition={{duration: 0.4, delay: 0.2}}
                                >
                                    <p className='font-bold text-xl sm:text-2xl md:text-3xl'>Tutoring</p>
                                    <div className='w-1 bg-indigo-500 h-8' />
                                </motion.div>

                                <motion.div
                                    initial={{opacity: 0}}
                                    animate={{opacity: 1, x: 0}}
                                    transition={{duration: 0.4, delay: 0.4}}
                                >
                                    <Mentorship />
                                </motion.div>
                            </>
                            :
                            <div className='h-96' />
                        }
                    </div>

                    <div
                        id='projects'
                        className='mt-12'
                        ref={projectsRef}
                    >
                        {projectsInView ?
                            <>
                                <motion.div
                                    className='my-4 flex  items-center mr-auto w-fit gap-4'
                                    initial={{opacity: 0, x: 50}}
                                    animate={{opacity: 1, x: 0}}
                                    transition={{duration: 0.4, delay: 0.2}}

                                >
                                    <div className='w-1 bg-indigo-500 h-8' />
                                    <p className='font-bold text-xl sm:text-2xl md:text-3xl'>Portfolio</p>

                                </motion.div>

                                <motion.div
                                    initial={{opacity: 0}}
                                    animate={{opacity: 1, x: 0}}
                                    transition={{duration: 0.4, delay: 0.4}}
                                >
                                    <Projects />
                                </motion.div>
                            </>
                            :
                            <div className='h-40' />
                        }

                    </div>

                    <div
                        ref={socialRef}
                        className='mt-12'
                        id="content"
                    >
                        {socialInView ?
                            <>
                                <motion.div
                                    className='my-4 text-right flex justify-right items-center ml-auto w-fit gap-4'
                                    initial={{opacity: 0, x: 50}}
                                    animate={{opacity: 1, x: 0}}
                                    transition={{duration: 0.4, delay: 0.2}}
                                >
                                    <p className='font-bold text-xl sm:text-2xl md:text-3xl'>Content</p>
                                    <div className='w-1 bg-indigo-500 h-8' />
                                </motion.div>

                                <motion.div
                                    initial={{opacity: 0}}
                                    animate={{opacity: 1}}
                                    transition={{duration: 0.4, delay: 0.4}}
                                    className='py-8'
                                >
                                    <SocialMediaHero />
                                </motion.div>
                            </>
                            :
                            <div className='h-96' />
                        }
                    </div>

                    <div
                        ref={experienceRef}
                        className='mt-20'
                        id="experience"
                    >
                        {experienceInView ?
                            <>
                                <motion.div 
                                    className='my-4 flex  items-center mr-auto w-fit gap-4'
                                    initial={{opacity: 0, x: 50}}
                                    animate={{opacity: 1, x: 0}}
                                    transition={{duration: 0.4, delay: 0.2}}
                                    
                                >
                                    <div className='w-1 bg-indigo-500 h-8' />
                                    <p className='font-bold text-xl sm:text-2xl md:text-3xl'>Resume</p>
                                </motion.div>
                                <motion.div
                                    initial={{opacity: 0, y: 50}}
                                    animate={{opacity: 1, y: 0}}
                                    transition={{duration: 0.4, delay: 0.4}}
                                >
                                    <Resume />
                                </motion.div>
                            </>
                            :
                            <div className='h-72' />
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}
export default BottomHalf